import _ from 'lodash';
// Theme stores the state of the current theme, and allows components to subscribe to future changes
function between(w, min, max) {
    return w >= min && w <= max;
}
var C_SCREEN_XS_CLASS = 'wdp-widget-xs';
var C_SCREEN_SM_CLASS = 'wdp-widget-sm';
var C_SCREEN_MD_CLASS = 'wdp-widget-md';
var C_SCREEN_LG_CLASS = 'wdp-widget-lg';

var C_SCREEN_XS = 420;
var C_SCREEN_SM = 768;
var C_SCREEN_MD = 992;

function detectScreenSize(width, cfg) {
    width = width || cfg.xs;

    if (between(width, 0, cfg.xs - 1)) return C_SCREEN_XS_CLASS;
    if (between(width, cfg.xs, cfg.sm - 1)) return C_SCREEN_SM_CLASS;
    if (between(width, cfg.sm, cfg.md - 1)) return C_SCREEN_MD_CLASS;
    if (between(width, cfg.md, 100000)) return C_SCREEN_LG_CLASS;

    return C_SCREEN_SM_CLASS;
}

var ScreenSizeObserver = function(px, cfg) {
    this.updateCfg(cfg);

    this.screenSize = detectScreenSize(px, this.cfg);
    this.subscriptions = [];
};

ScreenSizeObserver.prototype.updateCfg = function(cfg) {
    this.cfg = _.extend(
        {
            xs: C_SCREEN_XS,
            sm: C_SCREEN_SM,
            md: C_SCREEN_MD
        },
        cfg
    );
};

ScreenSizeObserver.prototype.isXS = function() {
    return this.screenSize === C_SCREEN_XS_CLASS;
};

ScreenSizeObserver.prototype.isSM = function() {
    return this.screenSize === C_SCREEN_SM_CLASS;
};

ScreenSizeObserver.prototype.isMD = function() {
    return this.screenSize === C_SCREEN_MD_CLASS;
};

ScreenSizeObserver.prototype.isLG = function() {
    return this.screenSize === C_SCREEN_LG_CLASS;
};

ScreenSizeObserver.prototype.getSS = function() {
    return this.screenSize.slice(-2);
};

ScreenSizeObserver.prototype.getScreenSize = function() {
    return this.screenSize;
};

ScreenSizeObserver.prototype.setScreenSize = function(screenSize) {
    this.screenSize = screenSize;
    this.subscriptions.forEach(f => f());
};

ScreenSizeObserver.prototype.onUpdateWidth = function(x) {
    this.setScreenSize(detectScreenSize(x, this.cfg));
};

ScreenSizeObserver.prototype.subscribe = function(f) {
    this.subscriptions.push(f);
};

ScreenSizeObserver.prototype.unsubscribe = function(f) {
    Reflect.deleteProperty(this.subscriptions, f);
};

module.exports = ScreenSizeObserver;



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/ScreenSizeObserver.js
 **/